import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";

type Role = {
  id: number;
  name: string;
  type_id: number;
};
type Props = CustomCellEditorProps & {};

function ProjectUserRoleSelectCellEditor(props: Props) {
  const { stopEditing, context, onValueChange } = props;
  const { allProjectRoles } = context;

  return (
    <Select
      data-testid="ProjectUserRoleSelect"
      open
      allowClear
      optionFilterProp="label"
      virtual={false}
      style={{ width: "100%" }}
      showSearch
      onChange={(id) => {
        onValueChange(id);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
      loading={!allProjectRoles}
      options={
        allProjectRoles
          ? allProjectRoles.map((role: Role) => ({
              value: role.id,
              label: role.name
            }))
          : []
      }
    />
  );
}

export default ProjectUserRoleSelectCellEditor;
